module.exports = __webpack_public_path__ + "static/media/howtoidcard.76ba0d7b.svg";